// src/ProductList.js
import React from 'react';
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useKeycloak} from "@react-keycloak/web";

const GET_PURCHASED_PRODUCTS = gql`
    {
        inventory {
            product {
                title
                sku
            }
            quantity
        }
    }
`;


const  PurchasedProducts = (props) =>  {
    const {keycloak, initialized} = useKeycloak();
    const { loading, error, data, previousData } = useQuery(GET_PURCHASED_PRODUCTS, {
        skip: !initialized || !keycloak.authenticated || !keycloak.token,
        pollInterval: keycloak.authenticated ? 5000 : 0,
        notifyOnNetworkStatusChange: false,
    });

    const resolvedData = data ?? previousData;

    if (loading && !resolvedData) return <p>Loading...</p>;
    if (error && !resolvedData) return <p>Error: {error.message}</p>;
    if (!resolvedData) return null;

    const products = resolvedData.inventory;

    function getPl() {
        return <ul>
            {products.map((item) => (
                <li key={item.product.sku}>
                    <strong>{item.product.title}</strong>
                </li>
            ))}
        </ul>;
    }

    return (
        <div>

            <div>
                {products.length > 0 ? (
                    <div>
                        <h2>Betalte medlemsskap</h2>
                        {getPl(products)}
                    </div>
                        ):<div/>}
                    </div>
                    </div>
                    );
                }


                export default PurchasedProducts;
